import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PageProgressService } from '../../../core/services/page-progress.service';
import { TranslationService } from '../../../core/services/i18n/translation.service';

/** A thin orange bar on top of every page while it loads; fixed, so it never moves the layout. */
@Component({
  selector: 'app-page-progress-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (progress.visible()) {
      <div
        role="progressbar"
        aria-busy="true"
        [attr.aria-label]="i18n.t('common.loading')"
        class="pointer-events-none fixed inset-x-0 top-0 z-[1500] h-[3px] overflow-hidden animate-doc-fade-in motion-reduce:animate-none"
      >
        <div
          class="h-full w-1/3 bg-accent animate-page-progress motion-reduce:w-full motion-reduce:animate-none"
        ></div>
      </div>
    }
  `,
})
export class PageProgressBarComponent {
  protected readonly progress = inject(PageProgressService);
  protected readonly i18n = inject(TranslationService);
}
